import { supabase } from '../../../core/lib/supabase';
import { configService } from '../../../shared/services/configService';

export interface FeedbackData {
  message_id: string;
  rating: 'like' | 'dislike';
  component?: string;
  reason?: string;
  comment?: string;
}

export const feedbackService = {
  /**
   * Envia feedback detallado a la tabla users_feedback
   */
  async submitFeedback(data: FeedbackData) {
    const config = configService.getConfig();
    
    // Si no tenemos userId en config, intentamos obtenerlo de la sesión actual
    // o simplemente lo enviamos sin userId si la tabla lo permite (aunque el SQL requiere user_id)
    let userId = config.userId;

    if (!userId) {
        // Intento de fallback
        const { data: { user } } = await supabase.auth.getUser();
        userId = user?.id || null;
    }

    if (!userId) {
        console.warn('⚠️ No user ID found for feedback submission');
        // Podríamos lanzar error, pero mejor loguear y evitar crash si es crítico
        // Asumiremos que el backend o RLS podría fallar si es null
    }

    const payload = {
      message_id: data.message_id,
      user_id: userId,
      component: data.component || 'agent',
      rating: data.rating,
      reason: data.reason,
      comment: data.comment
    };

    const { error } = await supabase
      .from('users_feedback')
      .insert(payload);

    if (error) {
      console.error('Error submitting feedback:', error);
      throw error;
    }
  }
};



